/**
 * 开发时默认启动：后台的 `/api` 还没有后端，不拦截的话首屏只有失败态。
 * 要对着真后端开发就 `pnpm dev:api`（`VITE_API_MOCKS=off`，请求走 vite 代理）。
 * 生产构建里 `import.meta.env.DEV` 是常量 false，这个分支连同 msw 一起被删掉。
 */
export async function startApiMocks(): Promise<void> {
  if (!import.meta.env.DEV || import.meta.env.VITE_API_MOCKS === "off") {
    return;
  }

  const { worker } = await import("./browser");

  try {
    await worker.start({ onUnhandledRequest: "bypass" });
  } catch (error) {
    // 有些浏览器环境不允许注册 Service Worker（内嵌预览、隐私模式等）。
    // 这时让应用照常渲染并去打真后端，别把首屏一起拖白。
    console.error("[mocks] Service Worker 注册失败，本次不拦截请求。", error);
  }
}
